export const MFO_FINAL_TEXTS = {
  LABEL: 'Детали заявки',
};
